import React, { useEffect } from 'react';
import { Form, Input, Modal, Select } from 'antd';

const GlobalBillCodeForm = ({ visible, onCreate, onCancel, record }) => {
  const [form] = Form.useForm();


  useEffect(() => {
    if (record) {
      console.log("record :", record);
      
      form.setFieldsValue({
        name: record.name,
        code: record.code,
      });
    }
    else {
      // Reset form when record is null (for adding new state)
      form.resetFields();
    }
  }, [record, form]);

  const handleChange = (value) => {
    console.log(`selected ${value}`);
  };

  // Custom validation rule for detecting spaces (leading, trailing, and in between)
  const validateNoSpaces = (rule, value) => {
    if (value && /\s/.test(value)) { // Regex to check for any space in the string
      return Promise.reject('Spaces are not allowed anywhere!');
    }
    return Promise.resolve();
  };

  return (
    <Modal
      visible={visible}
      title={record ? "Update Global Bill Code" : "Add Global Bill Code"}
      okText="Submit"
      cancelText="Cancel"
      // onCancel={onCancel}
      onCancel={() => {
        form.resetFields(); // Reset form fields when modal is closed
        onCancel(); // Call the onCancel handler
      }}
      onOk={() => {
        form
          .validateFields()
          .then(values => {
            onCreate(values);
            form.resetFields();
          })
          .catch(info => {
            console.log('Validate Failed:', info);
          });
      }}
      width={800}
    >
      <Form
        form={form}
        layout="vertical"
        name="model_form"
        initialValues={record}
      >
       
        <Form.Item
          name="name"
          label="Name"
          rules={[{ required: true, message: 'Please enter the global bill name!' }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="code"
          label="CODE"
          // rules={[{ required: true, message: 'Please enter the model code!' }]}
          rules={[
            { required: true, message: 'Please enter the model code!' },
            { validator: validateNoSpaces } // Add custom space validation
          ]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default GlobalBillCodeForm;